
import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';

export default function Testimonials() {
  const { t } = useTranslation();
  
  const testimonials = [
    {
      content: t('This is exactly what I was looking for! Learning English through BMX has made studying so much more enjoyable. The instructors really understand both languages and action sports.'),
      name: t('Yuki Tanaka'),
      role: t('BMX Rider'),
      avatar: 'https://public.readdy.ai/ai/img_res/75eb59f8681d920d0fbc783b1624e729.jpg',
      rating: 5
    },
    {
      content: t('I\'ve tried many English conversation schools, but this one is different. The skateboarding context makes everything click. My confidence in speaking English has improved dramatically.'),
      name: t('Sakura Yamamoto'),
      role: t('Skateboarder'),
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Japanese%20female%20skateboarder%20portrait%2C%20bright%20smile%20and%20energetic%20personality%2C%20wearing%20trendy%20streetwear%2C%20skateboard%20visible%20in%20background%2C%20professional%20headshot%20style%2C%20vibrant%20and%20positive%20atmosphere&width=200&height=200&seq=testimonial-2&orientation=squarish',
      rating: 5
    },
    {
      content: t('The community aspect is amazing. I\'ve made friends from around the world who share my passion for action sports and learning English.'),
      name: t('Hiroshi Sato'),
      role: t('Action Sports Enthusiast'),
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20action%20sports%20enthusiast%20portrait%2C%20mature%20and%20experienced%20appearance%2C%20wearing%20action%20sports%20gear%2C%20confident%20and%20friendly%20demeanor%2C%20professional%20headshot%20style%2C%20inspiring%20and%20motivational%20expression&width=200&height=200&seq=testimonial-3&orientation=squarish',
      rating: 5
    }
  ];
  
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('What Our Students Say')}
          </h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="p-8 text-center">
              <div className="mb-6">
                <div className="flex justify-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed text-lg italic">
                  "{testimonial.content}"
                </p>
              </div>
              
              <div className="flex items-center justify-center">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div className="text-left">
                  <h4 className="font-bold text-gray-900">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-600 text-sm">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
